/* !
 * newsroom.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _pagepath = location.pathname.startsWith('/en/') ? '/en/newsroom/' : '/newsroom/';

	const dropDown = () => {
		if (document.querySelector('.js-news-yearList')) {
			// 最新と最古の年を取得
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;
			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');
			const optionVal = (_num) => {
				if (_num === 'latest') {
					return _pagepath + 'latest/';
				} else {
					return _pagepath + _num + '/';
				}
			};
			// 「最新」オプションを追加
			const latestOption = document.createElement('option');
			latestOption.textContent = '最新';
			latestOption.value = optionVal('latest');
			document.querySelector('.js-news-yearList').appendChild(latestOption);
			
			// 最新から最古の年までのオプションを生成し追加
			for (var i = latest; i >= earliest; i--) {
				const option = document.createElement('option');
				option.textContent = i.toString();
				option.value = optionVal(i);
				document.querySelector('.js-news-yearList').appendChild(option);
			}
			// ドロップダウンリストで選択された年を設定
			const currentPath = location.pathname;
			if (currentPath.includes('/latest/')) {
				yearList.value = optionVal('latest');
			} else {
				yearList.value = currentPath;
			}
			// ドロップダウンリストの変更イベントを処理(ボタンの場合)
			// const yearListSubmit = document.querySelector('.js-news-yearList-submit');
			// yearListSubmit.addEventListener('click', function () {
			// 	location.href = yearList.value;
			// });

			// ドロップダウンリストの変更イベントを処理(プルダウンの場合)
			document.querySelector('.js-news-yearList').addEventListener('change', function () {
				location.href = yearList.value;
			});
		}
	};

	const commonSplideInit = () => {
		const isOverflowing = (splide) => {
			const Layout = splide.Components.Layout;
			return Layout.isOverflow();
		};
		const sliders = document.querySelectorAll('.js-common-slider');

		sliders.forEach((slider) => {
			const gap = slider.dataset.gap || '16px';

			const splide = new Splide(slider, {
				type: 'loop',
				autoplay: false,
				arrows: true,
				pagination: true,
				autoWidth: true,
				gap: gap,
				drag: true,
				breakpoints: {
					768: {
						gap: 16,
					},
				},
			});

			let prevOverflow = null;

			const updateByOverflow = () => {
				const overflow = isOverflowing(splide);

				// 状態が変わった時だけ更新
				if (overflow === prevOverflow) return;

				prevOverflow = overflow;

				splide.options = {
					type: overflow ? 'loop' : 'slide',
					drag: overflow,
					arrows: overflow,
					pagination: overflow,
				};
				splide.refresh();
			};

			// mounted の1回目だけ確実に実行
			splide.on('mounted', updateByOverflow);

			// resize 時は requestAnimationFrame で1フレ遅らせる
			splide.on('resized', () => {
				requestAnimationFrame(updateByOverflow);
			});

			splide.mount();
		});
	};

	// js-search-resetボタンでinput系をリセット
	const addSearchResetHandler = () => {
		const searchBoxes = document.querySelectorAll('.js-search-box');
		searchBoxes.forEach(box => {
			const resetBtn = box.querySelector('.js-search-reset');
			if (resetBtn) {
				resetBtn.addEventListener('click', () => {
					// input, select, textareaをリセット
					box.querySelectorAll('input, select, textarea').forEach(el => {
						if (el.type === 'checkbox' || el.type === 'radio') {
							el.checked = false;
						} else {
							el.value = '';
						}
					});
				});
			}
		});
	};

	// PC/SPフォーム同期処理（チェックボックス・セレクト・テキスト）
	const syncPCSPForm = () => {
		const searchBoxes = document.querySelectorAll('.js-search-box');
		searchBoxes.forEach(box => {
			const pairs = [
				{pc: 'p_category', sp: 'p_category_sp'},
				{pc: 'p_topics', sp: 'p_topics_sp'},
				{pc: 'p_keyword', sp: 'p_keyword_sp'},
				{pc: 'p_hashtag', sp: 'p_hashtag_sp'},
				{pc: 'year', sp: 'year_sp'}
			];
			pairs.forEach(pair => {
				const pcEls = box.querySelectorAll(`[name="${pair.pc}"]`);
				const spEls = box.querySelectorAll(`[name="${pair.sp}"]`);
				const sync = (src, dest) => {
					src.forEach((el, idx) => {
						el.addEventListener('change', () => {
							if (el.type === 'checkbox' || el.type === 'radio') {
								dest[idx] && (dest[idx].checked = el.checked);
							} else if (el.tagName === 'SELECT') {
								dest[idx] && (dest[idx].value = el.value);
							} else {
								dest[idx] && (dest[idx].value = el.value);
							}
						});
					});
				};
				// 双方向同期
				sync(pcEls, spEls);
				sync(spEls, pcEls);
			});
		});
	};

	// js-search-submitカスタムサブミット処理
	const addCustomSubmitHandler = () => {
		document.querySelectorAll('.js-search-submit').forEach(btn => {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				const box = btn.closest('.js-search-box');
				if (!box) return; // nullチェック追加
				const form = box.closest('form');
				let baseUrl = form?.getAttribute('action') || location.pathname;
				const yearSelect = box.querySelector('select[name="year"]');
				let url = baseUrl;
				if (yearSelect) {
					const yearVal = yearSelect.value;
					if (yearVal) {
						// 期間が設定されている場合は /newsroom/YYYY/ に変更
						url = url.replace(/\/(latest|\d{4})\/?$/, '/');
						if (!url.endsWith('/')) url += '/';
						url += `${yearVal}/`;
					} else {
						// 全ての期間は /newsroom/latest/
						url = url.replace(/\/(latest|\d{4})\/?$/, '/latest/');
						if (!url.endsWith('/latest/')) {
							if (url.endsWith('/')) {
								url += 'latest/';
							} else {
								url += '/latest/';
							}
						}
					}
				}
				// PC用input, select, textareaのみ取得
				const params = [];
				box.querySelectorAll('[data-view="pc"] input, [data-view="pc"] select, [data-view="pc"] textarea').forEach(el => {
					if (el.name && el.value && el.type !== 'checkbox' && el.type !== 'radio' && (!yearSelect || !el.matches('select[name="year"]'))) {
						params.push(`${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`);
					}
					if ((el.type === 'checkbox' || el.type === 'radio') && el.checked) {
						params.push(`${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`);
					}
				});
				if (params.length) {
					url += '?' + params.join('&');
				}
				location.href = url;
			});
		});
	};

	// 年プルダウン自動生成（最新年～2023年まで）
	const generateYearDropdown = () => {
		const allPeriodsText = location.pathname.startsWith('/en/') ? 'All periods' : '全ての期間';
		document.querySelectorAll('.js-search-box').forEach(box => {
			const latestYearEl = box.querySelector('.js-latest');
			if (!latestYearEl) return;
			const latestYear = parseInt(latestYearEl.textContent, 10);
			if (!latestYear || isNaN(latestYear)) return;
			const pcSelect = box.querySelector('select[name="year"]');
			const spSelect = box.querySelector('select[name="year_sp"]');
			if (pcSelect) {
				pcSelect.innerHTML = `<option value="">${allPeriodsText}</option>`;
				for (let y = latestYear; y >= Math.max(latestYear - 9, 2023); y--) {
					pcSelect.innerHTML += `<option value="${y}">${y}</option>`;
				}
			}
			if (spSelect) {
				spSelect.innerHTML = `<option value="">${allPeriodsText}</option>`;
				for (let y = latestYear; y >= Math.max(latestYear - 9, 2023); y--) {
					spSelect.innerHTML += `<option value="${y}">${y}</option>`;
				}
			}
		});
	};

	// 検索フォーム初期値セット（URLパラメータ反映＆PC/SP同期）
	const setSearchFormInitialValues = () => {
		const params = {};
		location.search.replace(/^\?/, '').split('&').forEach(pair => {
			const [key, val] = pair.split('=');
			if (!key) return;
			const decodedVal = decodeURIComponent(val || '');
			if (params[key]) {
				if (Array.isArray(params[key])) {
					params[key].push(decodedVal);
				} else {
					params[key] = [params[key], decodedVal];
				}
			} else {
				params[key] = decodedVal;
			}
		});
		// 年パスからも取得
		const yearMatch = location.pathname.match(/\/(\d{4})\//);
		if (yearMatch) {
			params.year = yearMatch[1];
		}
		// /latest/パスの場合は年パラメータをクリア
		if (location.pathname.includes('/latest/')) {
			delete params.year;
		}
		// 各js-search-boxごとに反映
		document.querySelectorAll('.js-search-box').forEach(box => {
			// PC用
			box.querySelectorAll('[data-view="pc"] input, [data-view="pc"] select, [data-view="pc"] textarea').forEach(el => {
				if (!el.name) return;
				const value = params[el.name];
				if (typeof value === 'undefined') return;
				if (el.type === 'checkbox' || el.type === 'radio') {
					if (Array.isArray(value)) {
						el.checked = value.includes(el.value);
					} else {
						el.checked = (el.value === value);
					}
				} else {
					el.value = Array.isArray(value) ? value[0] : value;
				}
			});
			// 年プルダウン
			const yearSelect = box.querySelector('select[name="year"]');
			if (yearSelect && params.year) {
				yearSelect.value = params.year;
			}
		});
		// PC/SP同期処理を即時実行
		syncPCSPForm();
	};

	// ピックアップ記事のトピックスタグ取得＆出力
	const renderPickupTags = async () => {
		const pickupIds = [];
		document.querySelectorAll('.rt_cf_pickup_id').forEach(span => {
			const id = span.textContent.trim();
			if (id) pickupIds.push(id);
		});
		if (!pickupIds.length) return;
		const url = (location.pathname.startsWith('/en/') ? '/ajax/en/newsroom/pickup/product_tag.json?' : '/ajax/newsroom/pickup/product_tag.json?') + pickupIds.map(id => `p_product=${encodeURIComponent(id)}`).join('&');
		try {
			const res = await fetch(url);
			const json = await res.json();
			const infoArr = json.rt_bn_news_info || [];
			infoArr.forEach(info => {
				const id = info._key;
				const tags = (info.cf_n_tags || []).map(tagObj => tagObj?.rt_cf_nt_name_topics?.content).filter(Boolean);
				const liList = Array.from(document.querySelectorAll('.rt_cf_pickup_id')).filter(span => span.textContent.trim() === id).map(span => span.closest('li')).filter(Boolean);
				liList.forEach(li => {
					const tagWrap = li.querySelector('.__tagWrap');
					if (tagWrap) {
						if (tags.length) {
							tagWrap.innerHTML = tags.map(tag => `<span class="mod-tag __type2">${tag}</span>`).join('');
						} else {
							tagWrap.remove(); // タグが無い場合は__tagWrapだけ削除
						}
					}
				});
			});
		} catch (e) {
			console.error('タグ取得失敗', e);
		}
	};

	// ピックアップ記事のli要素を3件までに制限
	const limitPickupItems = () => {
		const pickupElement = document.querySelector('.js-newsroom-pickup');
		if (!pickupElement) return;
		
		const splideList = pickupElement.querySelector('ul.splide__list');
		if (!splideList) return;
		
		const listItems = splideList.querySelectorAll('li');
		// 4件目以降の要素を削除
		for (let i = 3; i < listItems.length; i++) {
			listItems[i].remove();
		}
	};

	const newsFUNCTIONS = () => {
		limitPickupItems();
		dropDown();
		// createNews(); // ニュース描画が不要な案件では削除
		commonSplideInit();
		generateYearDropdown();
		setSearchFormInitialValues();
		addSearchResetHandler();
		syncPCSPForm();
		addCustomSubmitHandler();
		renderPickupTags();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
